import React from 'react';
import { APP_NAME } from '@apps/config';
import LoginScreen from '@apps/screens/Login';
import Head from 'next/head';
// import useTranslation from 'next-translate/useTranslation';

const LoginPage: React.FC = () => {
  // const { t } = useTranslation('screen');

  return (
    <>
      <Head>
        <title>{`Login - ${APP_NAME}`}</title>
      </Head>
      <LoginScreen />
    </>
  );
};

export default LoginPage;
